import { useQuery } from "@tanstack/react-query";

import type { ApiClient } from "../client";
import { useApiClient } from "../useApiClient";

import {
  ANALYTICS_QUERY_KEY,
  toAnalyticsQuery,
  type AnalyticsFilters,
} from "./useSummary";

export function distributionQueryOptions(
  client: ApiClient,
  filters: AnalyticsFilters = {},
) {
  return {
    queryKey: [...ANALYTICS_QUERY_KEY, "pnl-distribution", filters],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/analytics/pnl-distribution", {
        params: { query: toAnalyticsQuery(filters) },
      });
      if (error !== undefined) {
        throw new Error("Failed to load P&L distribution");
      }
      return data;
    },
  };
}

export function useDistribution(filters: AnalyticsFilters = {}) {
  const client = useApiClient();
  return useQuery(distributionQueryOptions(client, filters));
}
